import script from "./ActivationTelegramPage.vue?vue&type=script&setup=true&lang=js"
export * from "./ActivationTelegramPage.vue?vue&type=script&setup=true&lang=js"

import "./ActivationTelegramPage.vue?vue&type=style&index=0&id=ef9478ce&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ef9478ce"]])

export default __exports__